<script>
import highlightedRestaurants from '@/modules/mixins/highlightedRestaurants'

export default {
    name: 'FeaturedRestaurants',
    mixins: [highlightedRestaurants],
    data() {
        return {
            type: 'featured',
        }
    },
}
</script>

<template lang="pug">
.featured-restaurants
    h2.d-flex.align-items-baseline.justify-content-between {{$t('restaurant.featured')}}
        router-link.font-size-m.d-inline-flex.align-items-center(:to="{name: 'featured-restaurant-list', query: $route.query}")
            | {{$t('base.see_all')}}
            icon.ml-3(icon="fa-solid fa-long-arrow-alt-right")
    swiper(:loaded="total")
        restaurant-card(
            v-for="(restaurant, index) in list"
            :delay="restaurants.delay"
            :key="`featured-${restaurant.id}-${index}`"
            :model="restaurant"
            carousel)

</template>
